import { ApiService } from "../api.service";
import {
  PriceCheckItem,
  PriceCheckUpdate,
  PriceCheckPut,
  PriceCheckDelete,
} from "@/models/entities/priceCheck/priceCheck.interface";

const CONTROLLER = "priceCheck";
class PriceCheckService extends ApiService {
  getChecks() {
    return this.getAll<PriceCheckItem[]>(`${CONTROLLER}/GetAllPriceCheck`);
  }

  insertCheck(value: PriceCheckUpdate) {
    return this.post<PriceCheckUpdate, void>(
      `${CONTROLLER}/insertPriceCheck`,
      value
    );
  }

  updateCheck(value: PriceCheckPut) {
    return this.update<PriceCheckPut, void>(
      `${CONTROLLER}/updatePriceCheck`,
      value
    );
  }

  deleteCheck(id: PriceCheckDelete) {
    return this.post<PriceCheckDelete, void>(
      `${CONTROLLER}/deletePriceCheck`,
      id
    );
  }
}

export const priceCheckService = new PriceCheckService();
